import apiService from "./ApiService"
import { createQS } from "./Utils"

class TipoComponenteService {
  async get(termo, pagina) {
    try {
      const qs = createQS({ termo, pagina })
      return await apiService.get('tipo-componente?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get('tipo-componente/' + id)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('tipo-componente', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
  
  async update(id, data) {
    try {
      return await apiService.put('tipo-componente/' + id, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete('tipo-componente/' + id)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }  
}

const tipoComponenteService = new TipoComponenteService()
export default tipoComponenteService
